interface StandardContainerProps {
  children: React.ReactNode;
}

export const StandardContainer: React.FC<StandardContainerProps> = ({
  children,
}) => (
  <section className="grid grid-cols-1 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
    {children}
  </section>
);
